import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../style.css";
import ModalZoom from "../../preview/modalZoom";
import TSDialog from "../../general/dialog";
import { Modal } from "@ts-digital/vrc";
import NoPreview from "../../documentDetails/noPreview";
import { useDispatch, useSelector } from "react-redux";
import {
  loadFolderDetailContent,
  loadFolderDocumentPreview,
  loadFolderDocument,
  clearFolderPreview
} from "../../../store/actions/folders/detail";
import { FormattedMessage, useIntl } from "react-intl";
import { useState } from "react";
import FolderShareDialog from "../dialogs/share";
import NoFoldersResults from "./noResults";
import Cards from "./cards";
import Filters from "./filters";

const FoldersList = props => {
  const {    
    confirmDelete,
    isPermissionCreateFolders
  } = props;
  const navigate = useNavigate();
  const folders = useSelector(state => state.folders);
  const foldersDetail = useSelector(state => state.foldersDetail);
  const foldersList = folders.folders;
  const dispatch = useDispatch();
  const deleteConfirmText = useIntl().formatMessage({ id: "folders.deleteConfirm" });

  const [idToDelete, setIdToDelete] = useState(null);
  const [idToShare, setIdToShare] = useState(null);
  const [idToPopover, setIdToPopover] = useState(null);
  const [idToFlip, setIdToFlip] = useState(null);
  const [idToPreview, setIdToPreview] = useState(null);
  const [previewPage, setPreviewPage] = useState(1);
  const [filterOrder, setFilterOrder] = useState("update_new");
  const [filterText, setFilterText] = useState(null);
  const [searchValue, setSearchValue] = useState(null);

  // mount
  useEffect(() => {
    document.addEventListener("click", checkClick);

    // unmount
    return () => {
      document.removeEventListener("click", checkClick);
    };
  }, []);

  // Change idToFlip
  useEffect(() => {
    if (idToFlip) {
      dispatch(loadFolderDetailContent(idToFlip));
    }
    if (
      document.getElementsByClassName("Fascicoli-card-root") &&
      document.getElementsByClassName("Fascicoli-card-root").length > 0
    ) {
      let arrayCards = document.getElementsByClassName("Fascicoli-card-root");
      for (let cn in arrayCards) {
        if (arrayCards[cn].id && arrayCards[cn].id.split("_")[1] === idToFlip) {
          arrayCards[cn].classList.add("flipOn");
        } else {
          if (
            arrayCards[cn].classList &&
            arrayCards[cn].classList.contains("flipOff")
          ) {
            arrayCards[cn].classList.remove("flipOff");
          }
          if (
            arrayCards[cn].classList &&
            arrayCards[cn].classList.contains("flipOn")
          ) {
            arrayCards[cn].classList.remove("flipOn");
            arrayCards[cn].classList.add("flipOff");
          }
        }
      }
    }
  }, [idToFlip]);

  useEffect(() => {
    if (idToPreview) {
      dispatch(loadFolderDocumentPreview(idToPreview));
      dispatch(loadFolderDocument(idToPreview));
    }
  }, [idToPreview]);

  const checkClick = event => {
    if (
      event.target.id.indexOf("Fascicoli-cards-actions_") === -1 &&
      event.target.id.indexOf("Fascicoli-cards-actions-container_") === -1
    ) {
      setIdToPopover();
    }
  };

  const onActionClick = (action, folderId) => {
    if (action === "edit") {
      navigate(`/folders-edit/${folderId}`);
    }
    if (action === "delete") {
      setIdToDelete(folderId);
    }
    if (action === "share") {
      setIdToShare(folderId);
    }
  };

  const addPageModalZoom = () => {
    if (!idToPreview || foldersDetail.isLoadingPreview) {
      return null;
    }
    dispatch(loadFolderDocumentPreview(idToPreview,
      previewPage + 1));
    setPreviewPage(previewPage + 1);
    return undefined;
  };

  const renderDeleteDialog = () => {
    return (
      <TSDialog
        title={<FormattedMessage id="folders.pages.delete.confirm" />}
        okText={<FormattedMessage id="actions.delete" />}
        cancelText={<FormattedMessage id="actions.cancel" />}
        type="danger"
        visible={idToDelete ? true : false}
        onAbort={() => setIdToDelete()}
        onSubmit={e => {
          if (window.aptrinsic) {
            window.aptrinsic("track", "digital-box:FOLDERS-DELETE");
          }
          confirmDelete(idToDelete);
          setIdToDelete();
        }}
      >
        {deleteConfirmText}
      </TSDialog>
    );
  };

  return (
    <div>
      <Filters
        setFilterOrder={setFilterOrder}
        setFilterText={setFilterText}
        setSearchValue={setSearchValue}
        filterText={filterText}
        filterOrder={filterOrder}
      />
      <div className="Fascicoli-list-table-root">
        <Cards
          filterOrder={filterOrder}
          searchValue={searchValue}
          idToFlip={idToFlip}
          idToPopover={idToPopover}
          onActionClick={onActionClick}
          setIdToPopover={setIdToPopover}
          setIdToFlip={setIdToFlip}
          setIdToPreview={setIdToPreview}
        />
        {foldersList &&
          foldersList.length === 0 &&
          !folders.isGettingFolders && (
          <NoFoldersResults
 
            isPermissionCreateFolders={isPermissionCreateFolders}
          />
        )}
      </div>
      {renderDeleteDialog()}
      {idToShare && (
        <FolderShareDialog
          idToShare={idToShare}
          onClose={() => setIdToShare()}
        />
      )}
      {idToPreview && (
        <Modal
          visible={idToPreview}
          title={"Anteprima documento"}
          onClose={e => {
            dispatch(clearFolderPreview());
            setIdToPreview();
            setPreviewPage(1);
            document.getElementsByTagName("body")[0].style.overflow = "auto";
          }}
          type="primary"
          outsideClosable={false}
        >
          {/** openWindowContainer mi serve per riaggiustare i margini dell'anteprima */}
          <div className="openWindowContainer"></div>
          {!foldersDetail.isLoadingPreview &&
            foldersDetail.subjective &&
            !foldersDetail.preview ? (
              <NoPreview height={"calc(100vh - 350px)"} />
            ) : (
              <ModalZoom
                hideDownload
                imgSrc={
                  foldersDetail && foldersDetail.preview
                    ? `data:image/jpeg;base64,${foldersDetail.preview}`
                    : null
                }
                openPreviewPage={() => addPageModalZoom()}
                pagesTotal={
                  foldersDetail.documents && foldersDetail.documents[idToPreview]
                    ? foldersDetail.documents[idToPreview].numberOfPages
                    : 1
                }
                isLoading={foldersDetail.isLoadingPreview}
                waitForLoading={true}
                transparentBackground={true}
              />
            )}
        </Modal>
      )}
    </div>
  );
};

export default FoldersList;
